import { FormField } from 'global/components/Form'

interface IProps {
    placeholders?: {
        nomeResponsavel?: string
        email?: string
        telefoneResponsavel?: string
    }
}

export default function FormContato({ placeholders = {} }: IProps) {
    return (
        <>
            <FormField
                name="nomeContato"
                label="Nome do contato"
                placeholder={placeholders.nomeResponsavel}
                InputLabelProps={{ shrink: true }}
            />
            <FormField
                name="emailContato"
                label="Email para contato"
                type="email"
                InputLabelProps={{ shrink: true }}
                placeholder={placeholders.email}
            />
            <FormField
                name="telefoneContato"
                label="Telefone para contato (com DDD)"
                InputLabelProps={{ shrink: true }}
                placeholder={placeholders.telefoneResponsavel}
                options={{
                    phone: true,
                    phoneRegionCode: 'BR',
                }}
            />
        </>
    )
}
